<div fxLayout="column" fxLayoutAlign="start start" class="px-16 py-16 users">
  <app-check-list class="py-8 w-100-p user-group" [list]="userGroupCheckList" [multiselect]="false" [readOnly]="readOnly" (onChanged)="userGroupChanged($event)"></app-check-list>
  <mat-divider class="px-16 w-100-p"></mat-divider>
  <app-check-list class="py-8 w-100-p" [list]="userCheckList" [multiselect]="true" [readOnly]="readOnly" (onChanged)="usersChanged($event)"></app-check-list>
</div>